import { render, staticRenderFns } from "./modulo-permiso.vue?vue&type=template&id=409e57b0"
import script from "./modulo-permiso.vue?vue&type=script&lang=js"
export * from "./modulo-permiso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports